import Dexie from 'dexie';

import { IIndexedDBDatabaseSchema } from '../../interfaces/indexddb/indexeddb-database.interfaces';

export class IndexedDBDatabase extends Dexie {

    constructor(dbName: string, schema: Partial<IIndexedDBDatabaseSchema>) {
        super(dbName);

        // Create store
        const stores = this.getStoresFromSchema(schema);
        (this.version(1)).stores(stores);

    }

    private getStoresFromSchema(schema: Partial<IIndexedDBDatabaseSchema>) {
        return Object
            .keys(schema)
            .reduce<Record<string, string>>((store, key) => ({ ...store, [key]: schema[key].join(',') }), { });
    }

}
